import { createFileRoute } from '@tanstack/react-router';
import { RevisarVisitasView } from '@/modules/agronomia/components/RevisarVisitasView';

// Lista de revisão das visitas de uma fazenda (fluxo sincronizar → revisar).
export const Route = createFileRoute('/_authed/agronomia_/fazendas_/$id_/revisar')({
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  return <RevisarVisitasView imovelId={Number(id)} />;
}
